import { render, staticRenderFns } from "./MasterSVG.vue?vue&type=template&id=2be5856b&scoped=true"
import script from "./MasterSVG.vue?vue&type=script&lang=js"
export * from "./MasterSVG.vue?vue&type=script&lang=js"
import style0 from "./MasterSVG.vue?vue&type=style&index=0&id=2be5856b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be5856b",
  null
  
)

export default component.exports